var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M7.487 16C5.561 16 4 14.398 4 12.421v-.842C4 9.602 5.561 8 7.487 8h2.872v1.263H7.487c-1.246 0-2.256 1.037-2.256 2.316v.842c0 1.279 1.01 2.316 2.256 2.316h2.872V16zM16.513 8C18.439 8 20 9.602 20 11.579v.842C20 14.398 18.439 16 16.513 16H13.64v-1.263h2.872c1.246 0 2.256-1.037 2.256-2.316v-.842c0-1.279-1.01-2.316-2.256-2.316H13.64V8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M8.868 12.71h6.264v-1.42H8.868z"
  })));
};
export default SvgLink;